import {
  FETCH_LABELS_AND_PLACEHOLDER,
  FETCH_LABELS_AND_PLACEHOLDER_SUCCESS,
  FETCH_LABELS_AND_PLACEHOLDER_FAILED,
} from "../Constants/HomePageConstant";

const initialState = {
  elements: null,
  elementsStatus: false,
};

function homePageReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_LABELS_AND_PLACEHOLDER:
      return {
        ...state,
        elements: null,
        elementsStatus: true,
      };
    case FETCH_LABELS_AND_PLACEHOLDER_SUCCESS:
      return {
        ...state,
        elements: action.payload,
        elementsStatus: false,
      };
    case FETCH_LABELS_AND_PLACEHOLDER_FAILED:
      return {
        ...state,
        elements: null,
        elementsStatus: false,
      };

    default:
      return state;
  }
}

export default homePageReducer;

// {
//   "partnerWithUsElement": "Why should you partner with us?",
//   "royalEnfieldComElement": "royalenfield.com",
//   "topPartnerElement": "Top Partners",
//   "destinationPartnerElement": "Destinations",
//   "whoCanPartnerWithUsElement": "Who can Partner with us?",
//   "benefitsForThePartnerElement": "Benefits for the Partner",
//   "benefitsImage": "/main/assets/img/home_page/benefits_for_partner.webp",
//   "whoCanPartnerImage": "/main/assets/img/home_page/who_can_partner.webp",
//   "arrowRightImage": "/main/assets/img/icons/home_page_icons/arrow_right.svg",
//   "arrowLeftImage": "/main/assets/img/icons/home_page_icons/arrow_left.svg",
//   "bottomCardData": [
//     {
//       "subHeadingText": "Associate with a Global Brand",
//       "headingText": "How to become a partner?",
//       "ctaText": "Explore",
//       "backImg": "/main/assets/img/home_page/rental_partner.webp",
//       "redirectLink": "/guide/rental-guide"
//     },
//     {
//       "subHeadingText": "Associate with a Global Brand",
//       "headingText": "Start listing",
//       "ctaText": "Start Now",
//       "backImg": "/main/assets/img/home_page/start_listing.webp",
//       "redirectLink": "/partner/partner-dashboard"
//     },
//     {
//       "subHeadingText": "Log in to your account",
//       "headingText": "Existing user?",
//       "ctaText": "Login",
//       "backImg": "/main/assets/img/home_page/existing_user.webp",
//       "redirectLink": "/partner/login-account"
//     }
//   ],
//   "partnerWithUs": [
//     {
//       "subHeadingText": "A registered Motorcycle Rental Company",
//       "headingText": "That has commercially registered Royal Enfield ride(s).",
//       "logoImage": "/main/assets/img/icons/home_page_icons/rental_company.svg"
//     },
//     {
//       "subHeadingText": "A registered Tour Company with commercially",
//       "headingText": "registered Royal Enfield motorcycle(s) that conducts ride tours within India.",
//       "logoImage": "/main/assets/img/icons/home_page_icons/tour_company.svg"
//     },
//     {
//       "subHeadingText": "A registered Tour Company",
//       "headingText": "without motorcycles that conducts Ride Tours within India.",
//       "logoImage": "/main/assets/img/icons/home_page_icons/tour_company_c.svg"
//     }
//   ],
//   "benefitDetails": [
//     {
//       "benefitDetailsText": "Associate with a Global Brand",
//       "logoImage": "/main/assets/img/icons/home_page_icons/global_partner.webp"
//     },
//     {
//       "benefitDetailsText": "Gain presence in more than 50 countries with 21 website in 11+ languages",
//       "logoImage": "/main/assets/img/icons/home_page_icons/languages.webp"
//     },
//     {
//       "benefitDetailsText": "Your next big sales and marketing channel",
//       "logoImage": "/main/assets/img/icons/home_page_icons/new_sales.webp"
//     },
//     {
//       "benefitDetailsText": "Increase your reach to 1.2 million + unique visitors monthly",
//       "logoImage": "/main/assets/img/icons/home_page_icons/monthly_visitors.webp"
//     },
//     {
//       "benefitDetailsText": "Track all transactions. Receive secure and timely payments online",
//       "logoImage": "/main/assets/img/icons/home_page_icons/track_transection.webp"
//     },
//     {
//       "benefitDetailsText": "Transparent and equal opportunities",
//       "logoImage": "/main/assets/img/icons/home_page_icons/equal_n_transparent.webp"
//     }
//   ],
//   "destinationDetails": [
//     {
//       "nameElement": "Capetown",
//       "logoImage": "/main/assets/img/home_page/capetown.webp"
//     },
//     {
//       "nameElement": "Delhi",
//       "logoImage": "/main/assets/img/home_page/delhi.webp"
//     },
//     {
//       "nameElement": "France",
//       "logoImage": "/main/assets/img/home_page/france.webp"
//     },
//     {
//       "nameElement": "Leh",
//       "logoImage": "/main/assets/img/home_page/leh.webp"
//     },
//     {
//       "nameElement": "Manali",
//       "logoImage": "/main/assets/img/home_page/manali.webp"
//     },
//     {
//       "nameElement": "Shimla",
//       "logoImage": "/main/assets/img/home_page/shimla.webp"
//     }
//   ],
//   "ourTopPartners": [
//     {
//       "nameElement": "Vintage Rides",
//       "logoImage": "/main/assets/img/home_page/vintage_rides.webp"
//     },
//     {
//       "nameElement": "Motorcycle Expedition",
//       "logoImage": "/main/assets/img/home_page/motorcycle_expedition.webp"
//     },
//     {
//       "nameElement": "RETZA",
//       "logoImage": "/main/assets/img/home_page/retza.webp"
//     },
//     {
//       "nameElement": "Stonehead Bikes",
//       "logoImage": "/main/assets/img/home_page/stonehead_bikes.webp"
//     },
//     {
//       "nameElement": "Xplorearth",
//       "logoImage": "/main/assets/img/home_page/xplorearth.webp"
//     }
//   ]
// }
